<template>
    <div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    :finished-text="finish_text"
                    @load="load_list"
            >
                <div v-for="(item,index) in list" :key="index">
                    <product-item :p_product="item" />
                </div>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import ProductItem from "./ProductItem";

    export default {
        name: "ProductList",
        components: {ProductItem},
        data(){
            return{
                list:[],
                loading:false,
                finished:false,
                refreshing: false,
                load_qty:10,
                finish_text:'',
            }
        },
        methods:{
            ...mapActions([
                'GetProductPublishedList',
            ]),
            load_list(){
                if (this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }

                this.loading=true;
                let p={show_count:this.load_qty};
                this.GetProductPublishedList(p).then(res=>{
                    this.loading=false;
                    this.list=res.list;
                    if(this.list.length>10){
                        this.finish_text='我是底线';
                    }
                    if(this.load_qty>=res.total){
                        this.finished=true;
                    }else{
                        this.load_qty +=10;
                    }
                });
            },
            onRefresh() {
                // 清空列表数据
                this.finished = false;

                // 重新加载数据
                this.load_list();
            },
        },
        mounted() {
            this.load_list();
        }
    }
</script>

<style lang="scss" scoped>

</style>
